import { Button, Flex, Stack, Text } from '@mantine/core';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import type { BulkClaimOnBehalfRes } from '@dealstack/shared/lib/generated';
import type { BulkClaimGenerationJobStatusRes } from '@dealstack/shared/lib/backendClient';
import { BulkClaimGenerationProgress } from './BulkClaimGenerationProgress';
import { roleTypeLabel } from './BulkClaimOnBehalf.utils';

interface Props {
	result: BulkClaimOnBehalfRes;
	generationJobStatus: BulkClaimGenerationJobStatusRes | null;
	onClose: () => void;
}

export const BulkClaimOnBehalfResult = ({ result, generationJobStatus, onClose }: Props) => {
	const tMipManage = useTranslationMipManage();

	return (
		<Flex direction="column" gap="md" p="md">
			<Text size="sm">
				{tMipManage('documents_page.claim_on_behalf.result_summary', {
					claimed: result.claimed,
					skipped: result.skipped,
				})}
			</Text>

			<Stack gap="xs">
				{result.byRole.map((role) => (
					<Text key={role.roleType} size="sm">
						{tMipManage('documents_page.claim_on_behalf.result_role_breakdown', {
							role: roleTypeLabel(role.roleType, tMipManage),
							claimed: role.claimed,
							skipped: role.skipped,
						})}
					</Text>
				))}
			</Stack>

			{generationJobStatus && <BulkClaimGenerationProgress state={generationJobStatus} />}

			<Flex justify="flex-end">
				<Button variant="filled" onClick={onClose}>
					{tMipManage('documents_page.claim_on_behalf.close_button')}
				</Button>
			</Flex>
		</Flex>
	);
};
